import AuthProvider from "./provider/AuthProvider";
import InstalledAppsProvider from "./provider/InstalledAppsProvider";
import LanguageProvider from "./provider/LanguageProvider";
import { ConfirmHost } from "./components/ui/ConfirmDialog";
import Routes from "./routes";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <InstalledAppsProvider>
          <Routes />
          <ConfirmHost />
        </InstalledAppsProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
